
import { TemporaryDocument } from '@platform-ui/@types/document.js';
import cx from 'classnames';
import Color, { BackgroundColors, BorderColors } from '../../utilities/Color.js';
import Typography from '../Typography/index.js';
import { DateFormat, formatDate } from '@platform-ui-common/utilities/format.js';

interface DocumentItemProps { 
    document: TemporaryDocument;
    index: string;    
    mimetype: string;
    name?: string;
    pinned?: boolean;
    pinSelectedFile?: (id: string, pinned: boolean) => void;
    url: string;
    variant?: 'error';
    onOpen?: () => void;
}

export default function DocumentItem({
    document,
    index,
    mimetype,
    name,
    pinned,
    pinSelectedFile,
    url,
    variant,
    onOpen,
}: DocumentItemProps): JSX.Element {


enum DocumentType {
    Image = 'image',
    PDF = 'pdf',
    CSV = 'csv',
    Other = 'other',
}

const getDocumentType = (mimetype: string): DocumentType => {
    if (mimetype.match('image.*')) return DocumentType.Image;
    if (mimetype?.match('pdf')) return DocumentType.PDF;
    if (mimetype?.match('csv')) return DocumentType.CSV;
    return DocumentType.Other;
};

const type = getDocumentType(mimetype);
const noPreview = type === DocumentType.CSV;

return (
<div
    className={'w-full flex flex-col self-center text-left'}
    >
    <div
    className={cx('flex grow p-2 pl-6 border border-solid rounded-xl items-center', {
        [`${BorderColors[Color.Error]}`]: variant === 'error',
    })}
    aria-invalid={variant === 'error'}
    >
    {/* biome-ignore lint/a11y/useValidAnchor: used only for background tasks after file is opened in new tab */}
    <a
        className="flex grow items-center justify-items-left gap-x-2 overflow-auto break-all h-10"
        href={url}
        target="_blank"
        rel="noreferrer"
        onClick={onOpen}
    >
        {!noPreview && (
        <div
            className={`flex items-center justify-left shrink-0 overflow-hidden h-full w-13 ${
            BackgroundColors[Color.TableBackground]
            }`}
        >
            {type === DocumentType.Image && (
            // Only Safari supports HEIC/HEIF in img tags
            <img src={url} alt="Document Preview" className="max-w-full max-h-full" />
            )}
            {type === DocumentType.PDF && (
            <object
                data={url}
                className="max-w-full max-h-full"
                type="application/pdf"
                aria-label="Preview document"
            />
            )}
        </div>
        )}
        {name && <Typography variant="body">{name}</Typography>}
    </a>
    </div>
    {document.uploader && document.createdAt && (
    <div className="flex gap-2 mb-1">
        {document.createdAt && (
        <Typography variant="body" color={Color.TextSecondary}>
            Uploaded {formatDate(document.createdAt, DateFormat.DateTime)} by{' '}
            {document.uploader.name}
        </Typography>
        )}
    </div>
    )}
</div>
);
}